import React from "react";
import { varsomeHost } from "../../../../common/helpers/Urls";

const TermsOfUseAMP = () => (
  <div className="tw-w-90screen tw-max-w-3xl tw-p-4">
    <div className="prisma_modal__header">
      <h5 className="varsome-text-center">
        VarSome Somatic Variant Classification - Terms of Use
      </h5>
    </div>
    <div className="prisma_modal__body">
      <p>
        In 2017, the Association for Molecular Pathology (AMP), American Society
        of Clinical Oncology, and College of American Pathologists published a
        seminal paper describing a set of voluntary guidelines that could be
        followed in order to classify variants. These guidelines suggest a set
        of classifications and criteria, and also a method for evaluating the
        overall conclusion.
      </p>
      <p>
        VarSome attempts to evaluate a subset of these Somatic Variant
        Classification criteria for which public data are available and
        according to our interpretation of these criteria. These data may not be
        reliable and could lead to incorrect conclusions. Other rules cannot be
        evaluated either because they require additional data sources, or
        specific patient data.
      </p>
      <p>
        <strong>
          These limitations mean that this feature is experimental only, and
          should not be used for any medical purpose.
        </strong>
      </p>
      <p>
        The final verdict is calculated in accordance with the rules set out in
        the Somatic Variant Classification paper. The user can then tick /
        untick any of the findings to understand their impact on the overall
        verdict. This also allows the user to assess the impact of any
        additional information they may have, or, importantly, to disable a
        VarSome finding that they disagree with.
      </p>
      <p>
        This feature is very much experimental, we hope it is useful, and
        greatly appreciate your feedback or suggestions to help us improve our
        service.
      </p>
      <p>
        Please see the following link for VarSome’s overall terms of use:{" "}
        <a
          href={`${varsomeHost}/terms`}
          target="_blank"
        >{`${varsomeHost}/terms`}</a>
      </p>
    </div>
  </div>
);

export default TermsOfUseAMP;
